export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  loginBtn: "auth-login-btn",
  registerBtn: "auth-register-btn",
  googleBtn: "auth-google-btn",
  logoutBtn: "auth-logout-btn",
  toRegister: "auth-to-register",
  toLogin: "auth-to-login",
};
export const NAV = {
  brand: "nav-brand",
  dashboard: "nav-dashboard",
  map: "nav-map",
  topics: "nav-topics",
  profile: "nav-profile",
  progress: "nav-progress",
  admin: "nav-admin",
};
export const DASH = {
  recommendation: "dash-recommendation",
  startBtn: "dash-start-btn",
  totalQuestions: "dash-total-questions",
  overallAccuracy: "dash-overall-accuracy",
  totalSessions: "dash-total-sessions",
};
export const TOPIC = {
  card: (slug) => `topic-card-${slug}`,
  startBtn: (id) => `topic-start-${id}`,
};
export const SESSION = {
  progress: "session-progress",
  questionText: "session-question-text",
  choice: (k) => `session-choice-${k}`,
  next: "session-next",
  prev: "session-prev",
  finish: "session-finish",
};
export const RESULT = {
  score: "result-score",
  video: (ref) => `result-video-${ref}`,
  backHome: "result-back-home",
};
export const ADMIN = {
  navQuestions: "admin-nav-questions",
  navTopics: "admin-nav-topics",
  navTags: "admin-nav-tags",
  navStudents: "admin-nav-students",
  navVideoOps: "admin-nav-video-ops",
  editorText: "admin-editor-text",
  editorLatex: "admin-editor-latex",
  editorSaveBtn: "admin-editor-save",
  editorTopic: "admin-editor-topic",
  editorSubtopic: "admin-editor-subtopic",
  editorDifficulty: "admin-editor-difficulty",
  editorCorrect: "admin-editor-correct",
  editorChoice: (k) => `admin-editor-choice-${k}`,
  editorAddTag: "admin-editor-add-tag",
  editorSource: "admin-editor-source",
  editorYoutube: "admin-editor-youtube",
  editorExplanation: "admin-editor-explanation",
  editorImage: "admin-editor-image",
};
export const HOME = { emergentLink: "home-emergent-link" };
